import { Button } from "../../../../buttons/button/Button";

import "./imageUploaderModalButtons.scss";

export type Props = {
  closeModal: () => void;
  handleLooksGood?: () => void;
  canSubmit?: boolean;
  isUploading?: boolean;
  confirmationText?: string;
};

function ImageUploaderModalButtons({
  closeModal,
  handleLooksGood,
  canSubmit = true,
  isUploading,
  confirmationText = "Looks Good",
}: Props) {
  return (
    <div className="image-uploader-modal-buttons">
      <Button className="close" onClick={closeModal} basic color="blue">
        Cancel
      </Button>
      <Button className="looks-good" onClick={handleLooksGood} disabled={!canSubmit} primary loading={isUploading}>
        {confirmationText}
      </Button>
    </div>
  );
}

export default ImageUploaderModalButtons;
